import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { RATING_ROUTE } from "../utils/consts";
import { Stack } from "@mui/system";

const RatingItem = ({ review }) => {
  const navigate = useNavigate();

  return (
    <Card sx={{ width: 345, m: 1 }} elevation={12}>
      <CardActionArea onClick={() => navigate(RATING_ROUTE + "/" + review.id)}>
        <CardContent>
          <Stack direction="row" spacing={2}>
            <Typography gutterBottom component={"span"}>
              {`Оценка: ${review?.rating ?? '-'}`}
            </Typography>
            <Typography gutterBottom component={"span"}>
              {`Дата отзыва: ${new Date(review.createdAt)
                .toLocaleString()
                .substring(0, 17)}`}
            </Typography>
          </Stack>
          <Typography variant="body2" component={"div"}>
            {`Филиал: ${review.branch?.name || review.user?.branch?.name || "Не указан"}`}
          </Typography>
          <Typography variant="body2" component={"div"}>
            {`Врач: ` + review.doctorName}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default RatingItem;
